import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ax-dialog',{ref:"dialog",attrs:{"title":"Transfer","icon":"mdi-account-outline"},on:{"shown":_vm.onShow,"submitted":_vm.onSubmit}},[_c('template',{slot:"content"},[_c(VCardText,[_c(VAutocomplete,{attrs:{"label":"Select user(s)","items":_vm.options},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }